global.allSMSUserList = global.API_USER_URL+'allSMSUserList/';
global.SMSUserTypeDetails = global.API_USER_URL+'SMSUserTypeDetails/';
global.addNewSMSUserTemplate = global.API_USER_URL+'addNewSMSUserTemplate/';
global.editSMSUserTemplate = global.API_USER_URL+'editSMSUserTemplate/';
global.SMSUserManageDelete = global.API_USER_URL+'SMSUserManageDelete/'; 